import { HomeOutlined } from "@ant-design/icons";
import { Button, Col, notification } from "antd";
import fileDownload from "js-file-download";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { coreApi } from "../../api/calls";

/**
 * Building unit Export Button with functionality
 * @component
 * @alias BuildingUnitExportButton
 * @property {number} idCityBranch
 * @property {string} cityName
 * @property {primary} boolean - sets <Button /> style to primary - default false
 * @returns <Button />
 */
const BuildingUnitExportButton = ({ exportAll, idCityBranch, cityName, primary = false, dateFrom, dateTo }) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  return (
    <Col span={24}>
      <Button
        type={primary ? "primary" : "none"}
        loading={isLoading}
        icon={<HomeOutlined />}
        style={{ width: "100%" }}
        onClick={() => {
          setLoading(true);
          coreApi
            .get("/buildings/export/" + idCityBranch, {
              responseType: "blob",
              params: {
                exportAll: exportAll,
                dateFrom,
                dateTo,
              },
            })
            .then((response) => {
              fileDownload(
                response.data,
                cityName !== "" ? cityName + "-buildings-export.csv" : "buildings-export.csv"
              );
            })
            .catch((err) => notification.error({ message: err.response.data.message }))
            .finally(() => setLoading(false));
        }}
      >
        {t("exports.buildingUnitExport")}
      </Button>
    </Col>
  );
};

export default BuildingUnitExportButton;
